<ng-container *ngIf="GPSLocation; else noLocation">
  <button type="button" *ngIf="isGeoAPILoaded$ | async" class="btn btn-link" (click)="open(locationModal, $event)">
    View map
  </button>
  <div class="coordinates">Lat: {{ GPSLocation.lat }}</div>
  <div class="coordinates">Lon: {{ GPSLocation.lng }}</div>
</ng-container>

<ng-template #noLocation>
  <span data-test="no-location"> No location data </span>
</ng-template>

<ng-template #locationModal let-modal>
  <div class="modal-header">
    <h4 class="h4 modal-title" id="modal-basic-title">View Location</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <google-map width="100%" [center]="GPSLocation" [zoom]="16" (mapInitialized)="logGoogleMapsUsage()">
      <map-marker [position]="GPSLocation"></map-marker>
    </google-map>
  </div>
</ng-template>
